import type { GroupChatDocumentType, GroupChatVendorId, IGroupChatDocument } from "@common/types/api/r2-group-chat-types";
import { ExcelHost } from "@core/shared/office-hosts/excel-host";
import type { IOfficeHost } from "@core/shared/office-hosts/office-host.types";
import { OneNoteHost } from "@core/shared/office-hosts/onenote-host";
import { OutlookHost } from "@core/shared/office-hosts/outlook-host";
import { PowerPointHost } from "@core/shared/office-hosts/power-point-host";
import { WordHost } from "@core/shared/office-hosts/word-hosts";

const VENDOR_ID: GroupChatVendorId = 'microsoft';

export function mapHostToDocumentType(host: IOfficeHost): GroupChatDocumentType
{
    if (host instanceof WordHost) { return 'word'; }
    if (host instanceof ExcelHost) { return 'excel'; }
    if (host instanceof PowerPointHost) { return 'power_point'; }
    if (host instanceof OneNoteHost) { return 'note'; }
    if (host instanceof OutlookHost) { return 'mail'; }

    return 'word';
}

export function buildGroupChatDocument(host: IOfficeHost, id: string): IGroupChatDocument
{
    return {
        vendor_id: VENDOR_ID,
        type: mapHostToDocumentType(host),
        id: id.length < 256 ? id : id.slice(0, 255),
    };
}
